// ========== Start Account Form ==========
// Show/Hide password
const showPassIcons = document.querySelectorAll('.account-form__show-password');

showPassIcons.forEach(icon => {
  icon.addEventListener('click', function() {
    const inputPasword = icon.closest('.account-form__row').querySelector('.account-form__input');
    if (inputPasword.type === "password") {
      inputPasword.type = "text";
    } else {
      inputPasword.type = "password";
    }
  })
})
// ========== End Account Form ==========

// ========== Start Login Page ==========
// Login Switch
const loginSwitch = document.querySelectorAll('.customer-login__switch--type');
const loginSlider = document.querySelector('.customer-login__switch--slider');

loginSwitch.forEach(el => {
  el.addEventListener('click', function() {
    if (el.classList.contains('active')) return;

    // 1) Update active Class
    loginSwitch.forEach(btn => btn.classList.remove('active'));
    this.classList.add('active');

    // 2) Update Slider & Content
    const getType = this.getAttribute('data-type');
    const currentContent = document.querySelector('.customer-login__current-customer');
    const newContent = document.querySelector('.customer-login__new-customer');
    
    if (getType == 'current') {
      // Update Slider
      loginSlider.classList.remove('active-new');
      loginSlider.classList.add('active-current');

      // Update Content
      currentContent.classList.remove('hidden');
      newContent.classList.add('hidden');

    } else if (getType == 'new') {
      // Update Slider
      loginSlider.classList.remove('active-current');
      loginSlider.classList.add('active-new');

      // Update Content
      currentContent.classList.add('hidden');
      newContent.classList.remove('hidden');
      newContent.classList.remove('hide-mobile');
    } 
  })
})

window.addEventListener('resize', function() {
  const currentContent = document.querySelector('.customer-login__current-customer');
  const newContent = document.querySelector('.customer-login__new-customer');
  if (!currentContent) return;

  if (window.innerWidth > 749) {
    currentContent.classList.remove('hidden');
    newContent.classList.remove('hidden');
  } else {
    if (loginSlider.classList.contains('active-current')) {
      currentContent.classList.remove('hidden');
      newContent.classList.add('hidden');

    } else if (loginSlider.classList.contains('active-new')) {
      currentContent.classList.add('hidden');
      newContent.classList.remove('hidden');
      newContent.classList.remove('hide-mobile');
    } 
  }
})

// Adjust Reset Pass Height
const adjustResetPassHeight = function() {
  const resetPassContent = document.querySelector('.customer-login__reset-password');
  if (!resetPassContent) return;
  const customerTypeHeight = parseInt(getComputedStyle(document.querySelector('.customer-login__customer-type')).height);

  if (window.innerWidth > 749) {
    resetPassContent.style.height = `${customerTypeHeight}px`;
  } else {
    resetPassContent.style.height = 'auto';
  }
}

document.addEventListener('DOMContentLoaded', adjustResetPassHeight)
window.addEventListener('resize', adjustResetPassHeight)

// ========== End Login Page ==========

// ========== Start Account Banner ==========
// Mobile Menu
const mobileMenuHeading = document.querySelector('.menu-mobile__heading');
if (mobileMenuHeading) {
  mobileMenuHeading.addEventListener('click', function() {
    const mobileSubMenu = document.querySelector('.menu-mobile__sub-menu');
  
    // 1- Open Class
    this.classList.toggle('open');
  
    // 2- Open/Close Sub-menu
    if (this.classList.contains('open')) {
      mobileSubMenu.classList.remove('hidden');
    } else {
      mobileSubMenu.classList.add('hidden');
    }
  })
}
// ========== End Account Banner ==========

// ========== Start Account Page / Show All Orders ==========
const viewAllOrdersBtns = document.querySelectorAll('.js-view-all-orders');

const showAllOrders = function() {
  const accountHome = document.querySelector('.customer-account__container');
  const allOrdersContainer = document.querySelector('.orders__container');
  const allAccountBannerItems = document.querySelectorAll('.account-banner__menu-item');
  const bannerDropdownMen = document.querySelector('.menu-mobile__heading');

  // 1- Update banner Menu
  allAccountBannerItems.forEach(item => {
    const itemLink = item.querySelector('a');

    if (item.classList.contains('sub-menu__orders') || item.classList.contains('menu-mobile__orders')) {
      itemLink.classList.add('active');
    } else {
      itemLink.classList.remove('active');
    }
  })

  // 2- Close banner dropdown Menu if opened
  if (bannerDropdownMen.classList.contains('open')) bannerDropdownMen.click();

  // 3- Show All Orders
  accountHome.classList.add('hidden');
  allOrdersContainer.classList.remove('hidden');
}

viewAllOrdersBtns.forEach(btn => {
  btn.addEventListener('click', function() {
    showAllOrders();
  })
}) 

// Show All Orders form the URL
document.addEventListener('DOMContentLoaded', function() {
  if (window.location.toString().includes("#orders")) {
    showAllOrders();
  }
})
// ========== End Account Page / Show/Hide All Orders ==========

// ========== Start Addresses page ==========
// Open New Address Modal
const addAddressBtn = document.querySelector('.add-address-btn');
if (addAddressBtn) {
  addAddressBtn.addEventListener('click', function() {
    const newAddressModal = document.querySelector('.new-address-modal');
    const addressContainer = document.querySelector('.main-addresses__container');

    newAddressModal.classList.remove('hidden');
    addressContainer.classList.add('hidden');
  })
}

// Close New Address Modal
const newAddressClose = document.querySelector('.new-address__close');
if (newAddressClose) {
  newAddressClose.addEventListener('click', function() {
    const newAddressModal = document.querySelector('.new-address-modal');
    const addressContainer = document.querySelector('.main-addresses__container');

    newAddressModal.classList.add('hidden');
    addressContainer.classList.remove('hidden');
  })
}

// Open Edit Address Modal
const editAddressBtn = document.querySelectorAll('.address-card__edit');
if (editAddressBtn) {
  editAddressBtn.forEach(btn => {
    btn.addEventListener('click', function() {
      const addressID = btn.dataset.id;
      const relatedAddress = document.querySelector(`.edit-address-modal[data-id='${addressID}']`);
      const addressContainer = document.querySelector('.main-addresses__container');

      relatedAddress.classList.remove('hidden');
      addressContainer.classList.add('hidden');
    })
  })
}

// Close Edit Address Modal
const editAddressClose = document.querySelectorAll('.edit-address__close');
if (editAddressClose) {
  editAddressClose.forEach(btn => {
    btn.addEventListener('click', function() {
      const addressContainer = document.querySelector('.main-addresses__container');


      document.querySelectorAll('.edit-address-modal').forEach(el => el.classList.add('hidden'));
      addressContainer.classList.remove('hidden');
    })
  })
}

// Country & Province Update
class CustomerAddress {
  constructor() {
    this.initCustomerAddress();
    this.customerAddressSelector();
  }

  initCustomerAddress() {
    const allAddressesSelector = document.querySelectorAll('select[data-country-selector]');
    if (allAddressesSelector.length < 1 ) return;

    allAddressesSelector.forEach(select => {
      const selecedCountry = this.getSelectedCountry(select);

      if (selecedCountry) {
        const provinces = selecedCountry.dataset.provinces;
        const arrayOfProvinces = JSON.parse(provinces);
        const provincesSelector = document.querySelector(`#address_province_${select.dataset.id}`);
  
        if (arrayOfProvinces.length > 1) provincesSelector.closest('.account-form__row').style.display = 'block';
  
        provincesSelector.innerHTML = '';
        let options = '';
  
        arrayOfProvinces.forEach(province => {
          if (province[0] === provincesSelector.getAttribute('value')) {
            options += `<option value="${province[0]}" selected>${province[0]}</option>`;
          } else {
            options += `<option value="${province[0]}">${province[0]}</option>`;
          }
        })
  
        provincesSelector.innerHTML = options;
      }
    })
  }

  getSelectedCountry(select) {
    let option, selectedOption;

    for (let index = 0; index < select.options.length; index++) {
      option = select.options[index];

      if (option.value === select.getAttribute('value')) {
        selectedOption = option;
        selectedOption.setAttribute('selected', 'selected');
        break;
      }
    }

    return selectedOption;
  }

  customerAddressSelector() {
    const addressesSelector = document.querySelectorAll('select[data-country-selector]');
    if (addressesSelector.length < 1) return;

    addressesSelector.forEach(select => {
      select.addEventListener('change', function(e) {
        const provinces = select.options[select.selectedIndex].dataset.provinces
        const arrayOfProvinces = JSON.parse(provinces);
        const provincesSelector = document.querySelector(`#address_province_${select.dataset.id}`);

        if (arrayOfProvinces.length > 1) {
          provincesSelector.closest('.account-form__row').style.display = 'block';
        } else {
          provincesSelector.closest('.account-form__row').style.display = 'none';
        }

        provincesSelector.innerHTML = '';
        let options = '';
  
        arrayOfProvinces.forEach(province => {
          options += `<option value="${province[0]}">${province[0]}</option>`;
        })
  
        provincesSelector.innerHTML = options;
      })
    })
  }
}

const customerAddress = new CustomerAddress();
// ========== End Addresses page ==========